import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const divisionsCollection = collection(db, "divisions");

const divisionsService = { 
  getAll: async () => {
    try {  
      const divisionsSnapshot = await getDocs(divisionsCollection);
      const divisionsList = divisionsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      return divisionsList;
    } catch (error) {
      console.error('Error fetching divisions:', error);
      throw error;
    }
  },
  add: async (divisionsData) => {
    try {
      const docRef = await addDoc(divisionsCollection, divisionsData);
      return docRef;
    } catch (error) {
      console.error('Error adding division:', error);
      throw error;
    }
  },
  edit: async ({ id, data }) => {
    try {
      const divisionRef = doc(db, 'divisions', id);
      await updateDoc(divisionRef, data);
    } catch (error) {
      console.error('Error updating division:', error);
      throw error;
    }
  },
  delete: async (divisionId) => {
    try {
     await deleteDoc(doc(db, "divisions", divisionId));
     return true;
    } catch (error) {
      console.error('Error deleting division:', error);
      throw error;
    }
  },
  getIdByName: async (divisionName) => {
    try {
      const divisionsSnapshot = await getDocs(divisionsCollection);
      const divisionList = divisionsSnapshot.docs.map(doc => ({
        id: doc.id,
       ...doc.data()
      }));

      const formattedDivisionName = divisionName.trim().toLowerCase().replace(/\s+/g, '');
      
      const division = divisionList.find(division => division.name.toLowerCase().replace(/\s+/g, '') === formattedDivisionName);
      return division ? division.id : null;
     
    } 
    catch (error) {
      console.error('Error getting division ID:', error);
      throw error;
    }
  },

  getNameById: async (divisionId) => {
    if (!divisionId) return null;
    try {
     const divisionRef = doc(db, 'divisions', divisionId);
     const divisionSnap = await getDoc(divisionRef);

     if (divisionSnap.exists()) {
       return divisionSnap.data().name;  
     }
     else {
       return null; 
     }
    } 
    catch (error) {
      console.error('Error getting division name:', error);
      throw error; 
    }
  },
  getAcronymById: async (divisionId) => {
    try {
     const divisionRef = doc(db, 'divisions', divisionId);
     const divisionSnap = await getDoc(divisionRef);

     if (divisionSnap.exists()) {
       return divisionSnap.data().acronym;  
     }
     else {
       return null; 
     }
    } 
    catch (error) {
      console.error('Error getting division name:', error);
      throw error; 
    }
  },


};

export default divisionsService;
